










import { Vue, Component, Prop } from "vue-property-decorator";
import { HTTP } from "@/services/http-service";
import IdentityProviders from "../components/common/IdentityProviders.vue";

@Component({
  components: { IdentityProviders }
})
export default class Discovery extends Vue {}
